export default {"src":"/_next/static/media/verizon.7df05583.svg","height":26,"width":118,"blurWidth":0,"blurHeight":0};